<div class="dashboard-container">
  <!-- Header -->
  <app-staff-header [currentUser]="currentUser" (logout)="onLogout()">
  </app-staff-header>

  <!-- Main Content -->
  <div class="dashboard-content">
    <!-- Navigation -->
    <app-staff-nav [isMobileMenuOpen]="isMobileMenuOpen" (navigate)="onNavigate($event)"
      (closeMobileMenu)="closeMobileMenu()">
    </app-staff-nav>

    <!-- Content Area -->
    <div class="dashboard-main">
      <div class="main-content">
        <!-- Page Header -->
        <div class="content-header">
          <h1 class="page-title">จัดการรายการชำระเงิน</h1>
          <p class="page-subtitle">ระบบตรวจสอบและอนุมัติการชำระเงิน</p>
        </div>

        <!-- Error Alert -->
        <ngb-alert *ngIf="error" type="danger" [dismissible]="true" class="mb-3">
          {{ error }}
        </ngb-alert>

        <!-- Status Tabs -->
        <div class="status-tabs-container">
          <div class="status-tabs">
            <button *ngFor="let tab of tabs" type="button" class="status-tab" [class.active]="activeTab === tab.id"
              (click)="switchTab(tab.id)">
              <span class="tab-label">{{ tab.label }}</span>
            </button>
          </div>
        </div>

        <!-- Filters Section -->
        <div class="filters-section">
          <div class="filters-header">
            <h3>ตัวกรอง</h3>
            <button type="button" class="clear-filters-btn" (click)="clearFilters()">
              ล้างตัวกรอง
            </button>
          </div>

          <div class="filters-grid">
            <!-- Search Term -->
            <div class="filter-group">
              <label class="form-label">ค้นหาทั่วไป</label>
              <input type="text" class="form-control" [(ngModel)]="filters.searchTerm" (ngModelChange)="applyFilters()"
                placeholder="อีเมล, ชื่อ-นามสกุล, เลขที่ใบเสร็จ, รายการ">
            </div>

            <!-- Email -->
            <div class="filter-group">
              <label class="form-label">อีเมล</label>
              <input type="text" class="form-control" [(ngModel)]="filters.email" (ngModelChange)="applyFilters()"
                placeholder="อีเมลผู้ใช้">
            </div>

            <!-- Receipt Code -->
            <div class="filter-group">
              <label class="form-label">เลขที่ใบเสร็จ</label>
              <input type="text" class="form-control" [(ngModel)]="filters.codeReceipt" (ngModelChange)="applyFilters()"
                placeholder="เช่น mem-69-000001">
            </div>

            <!-- Item Title -->
            <div class="filter-group">
              <label class="form-label">ชื่อรายการ</label>
              <input type="text" class="form-control" [(ngModel)]="filters.itemTitle" (ngModelChange)="applyFilters()"
                placeholder="ชื่อรายการ / ประเภท">
            </div>

            <!-- Receipt Type (created / canceled) -->
            <div class="filter-group">
              <label class="form-label">ประเภทใบเสร็จ</label>
              <select class="form-select" [(ngModel)]="filters.receiptType" (ngModelChange)="applyFilters()">
                <option value="">ทั้งหมด</option>
                <option value="created">สร้างใหม่</option>
                <option value="canceled">ยกเลิก</option>
              </select>
            </div>

            <!-- Amount Min -->
            <div class="filter-group">
              <label class="form-label">จำนวนเงินขั้นต่ำ</label>
              <input type="number" class="form-control" [(ngModel)]="filters.amountMin" (ngModelChange)="applyFilters()"
                placeholder="0.00" min="0" step="0.01">
            </div>

            <!-- Amount Max -->
            <div class="filter-group">
              <label class="form-label">จำนวนเงินสูงสุด</label>
              <input type="number" class="form-control" [(ngModel)]="filters.amountMax" (ngModelChange)="applyFilters()"
                placeholder="999999.99" min="0" step="0.01">
            </div>

            <!-- Date From -->
            <div class="filter-group">
              <label class="form-label">วันที่ชำระเริ่มต้น</label>
              <input type="date" class="form-control" [(ngModel)]="filters.dateFrom" (ngModelChange)="applyFilters()">
            </div>

            <!-- Date To -->
            <div class="filter-group">
              <label class="form-label">วันที่ชำระสิ้นสุด</label>
              <input type="date" class="form-control" [(ngModel)]="filters.dateTo" (ngModelChange)="applyFilters()">
            </div>
          </div>

          <!-- Action Buttons -->
          <div class="d-flex gap-2 mt-3">
            <button type="button" class="btn btn-outline-success" (click)="exportToCSV()"
              [disabled]="isExporting || currentFilteredCount === 0">
              <span *ngIf="isExporting" class="spinner-border spinner-border-sm me-2"></span>
              <i *ngIf="!isExporting" class="bi bi-file-earmark-excel me-2"></i>
              {{ isExporting ? 'กำลัง Export...' : 'Export CSV' }}
            </button>
            <button type="button" class="btn btn-primary" (click)="refreshData()">
              <i class="bi bi-arrow-clockwise me-2"></i>รีเฟรชข้อมูล
            </button>
          </div>
        </div>

        <!-- Loading Spinner -->
        <div *ngIf="isLoading" class="account-worklist-container">
          <div class="loading-state">
            <div class="loading-spinner"></div>
            <p>กำลังโหลดข้อมูลรายการชำระเงิน...</p>
          </div>
        </div>

        <!-- Payment Records Table -->
        <div class="card" *ngIf="!isLoading">
          <div class="card-header d-flex justify-content-between align-items-center">
            <h5 class="card-title mb-0">รายการชำระเงินทั้งหมด</h5>
            <div class="d-flex align-items-center gap-2">
              <span class="text-muted">แสดงผล:</span>
              <select class="form-select form-select-sm w-auto" [(ngModel)]="pageSize"
                  (ngModelChange)="changePageSize(pageSize)" aria-label="จำนวนรายการต่อหน้า">
                  <option *ngFor="let size of pageSizeOptions" [ngValue]="size">{{ size }} รายการ</option>
                </select>
            </div>
          </div>

          <div class="card-body p-0">
            <!-- Table -->
            <div class="table-responsive">
              <table class="table table-striped table-hover mb-0">
                <thead class="table-light">
                  <tr>
                    <!-- 1. วันและเวลาที่ User เข้าทำรายการในระบบ -->
                    <th scope="col" class="sortable" (click)="sortBy('submittedAt')"
                      [class.sorted]="isSortedBy('submittedAt')" title="คลิกเพื่อเรียงลำดับ">
                      วันและเวลาที่ทำรายการ {{ getSortIcon('submittedAt') }}
                    </th>
                    <!-- 2. ชื่อ-นามสกุล User -->
                    <th scope="col" class="sortable" (click)="sortBy('name')"
                      [class.sorted]="isSortedBy('name')" title="คลิกเพื่อเรียงลำดับ">
                      ชื่อ-นามสกุล {{ getSortIcon('name') }}
                    </th>
                    <!-- 3. เลขที่สมาชิกสมาคม -->
                    <th scope="col" class="sortable" (click)="sortBy('memberNo')"
                      [class.sorted]="isSortedBy('memberNo')" title="คลิกเพื่อเรียงลำดับ">
                      เลขที่สมาชิกสมาคม {{ getSortIcon('memberNo') }}
                    </th>
                    <!-- 4. บริษัท/หน่วยงาน -->
                    <th scope="col" class="sortable" (click)="sortBy('organization')"
                      [class.sorted]="isSortedBy('organization')" title="คลิกเพื่อเรียงลำดับ">
                      บริษัท/หน่วยงาน {{ getSortIcon('organization') }}
                    </th>
                    <!-- 5. ชื่อรายการ -->
                    <th scope="col" class="sortable" (click)="sortBy('itemTitle')"
                      [class.sorted]="isSortedBy('itemTitle')" title="คลิกเพื่อเรียงลำดับ">
                      ชื่อรายการ {{ getSortIcon('itemTitle') }}
                    </th>
                    <!-- 6. จำนวนเงิน -->
                    <th scope="col" class="sortable text-end" (click)="sortBy('amount')"
                      [class.sorted]="isSortedBy('amount')" title="คลิกเพื่อเรียงลำดับ">
                      จำนวนเงิน {{ getSortIcon('amount') }}
                    </th>
                    <!-- 7. สถานะการชำระเงิน -->
                    <th scope="col" class="sortable text-center" (click)="sortBy('paymentStatus')"
                      [class.sorted]="isSortedBy('paymentStatus')" title="คลิกเพื่อเรียงลำดับ">
                      สถานะการชำระเงิน {{ getSortIcon('paymentStatus') }}
                    </th>
                    <!-- 8. วันที่และเวลาชำระเงิน -->
                    <th scope="col" class="sortable" (click)="sortBy('paidAt')"
                      [class.sorted]="isSortedBy('paidAt')" title="คลิกเพื่อเรียงลำดับ">
                      วันที่และเวลาชำระเงิน {{ getSortIcon('paidAt') }}
                    </th>
                    <!-- 9. หลักฐานการชำระเงิน -->
                    <th scope="col" class="sortable text-center" (click)="sortBy('paymentSlip')"
                      [class.sorted]="isSortedBy('paymentSlip')" title="คลิกเพื่อเรียงลำดับ (มี/ไม่มีหลักฐาน)">
                      หลักฐานการชำระเงิน {{ getSortIcon('paymentSlip') }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <!-- No Data Row -->
                  <tr *ngIf="!isLoading && getCurrentPageRecords().length === 0">
                    <td colspan="9" class="text-center py-4">
                      <div class="text-muted">
                        <i class="bi bi-inbox"></i>
                        <p class="mb-0">ไม่พบข้อมูลรายการชำระเงิน</p>
                        <small
                          *ngIf="activeTab === 'member-card' && memberCardRecords.length === 0">ไม่มีข้อมูลในระบบ</small>
                        <small
                          *ngIf="activeTab === 'member-card' && memberCardRecords.length > 0 && filteredMemberCardRecords.length === 0">ไม่พบข้อมูลที่ตรงกับเงื่อนไขการกรอง</small>
                        <small
                          *ngIf="activeTab === 'renew-member' && renewMemberRecords.length === 0">ไม่มีข้อมูลในระบบ</small>
                        <small
                          *ngIf="activeTab === 'renew-member' && renewMemberRecords.length > 0 && filteredRenewMemberRecords.length === 0">ไม่พบข้อมูลที่ตรงกับเงื่อนไขการกรอง</small>
                        <small
                          *ngIf="activeTab === 'register-appraiser' && regisAppraiserRecords.length === 0">ไม่มีข้อมูลในระบบ</small>
                        <small
                          *ngIf="activeTab === 'register-appraiser' && regisAppraiserRecords.length > 0 && filteredRegisAppraiserRecords.length === 0">ไม่พบข้อมูลที่ตรงกับเงื่อนไขการกรอง</small>
                        <small
                          *ngIf="activeTab === 'renew-appraiser' && renewAppraiserRecords.length === 0">ไม่มีข้อมูลในระบบ</small>
                        <small
                          *ngIf="activeTab === 'renew-appraiser' && renewAppraiserRecords.length > 0 && filteredRenewAppraiserRecords.length === 0">ไม่พบข้อมูลที่ตรงกับเงื่อนไขการกรอง</small>
                        <small
                          *ngIf="activeTab === 'training' && trainingRecords.length === 0">ไม่มีข้อมูลในระบบ</small>
                        <small
                          *ngIf="activeTab === 'training' && trainingRecords.length > 0 && filteredTrainingRecords.length === 0">ไม่พบข้อมูลที่ตรงกับเงื่อนไขการกรอง</small>
                        <small *ngIf="activeTab === 'exam' && examRecords.length === 0">ไม่มีข้อมูลในระบบ</small>
                        <small
                          *ngIf="activeTab === 'exam' && examRecords.length > 0 && filteredExamRecords.length === 0">ไม่พบข้อมูลที่ตรงกับเงื่อนไขการกรอง</small>
                        <small
                          *ngIf="activeTab !== 'member-card' && activeTab !== 'renew-member' && activeTab !== 'register-appraiser' && activeTab !== 'renew-appraiser' && activeTab !== 'training' && activeTab !== 'exam' && records.length === 0">ไม่มีข้อมูลในระบบ</small>
                        <small
                          *ngIf="activeTab !== 'member-card' && activeTab !== 'renew-member' && activeTab !== 'register-appraiser' && activeTab !== 'renew-appraiser' && activeTab !== 'training' && activeTab !== 'exam' && records.length > 0 && filteredRecords.length === 0">ไม่พบข้อมูลที่ตรงกับเงื่อนไขการกรอง</small>
                      </div>
                    </td>
                  </tr>

                  <!-- Record Rows -->
                  <tr *ngFor="let record of getCurrentPageRecords(); trackBy: trackByRecordId" class="clickable-row"
                    (click)="viewRecord(record)" style="cursor: pointer;" title="คลิกเพื่อดูรายละเอียดการชำระเงิน">
                    <!-- 1. วันและเวลาที่ User เข้าทำรายการในระบบ -->
                    <td class="text-nowrap">{{ getRowSubmittedAt(record) }}</td>

                    <!-- 2. ชื่อ-นามสกุล User -->
                    <td class="fw-semibold">{{ getRowFullName(record) }}</td>

                    <!-- 3. เลขที่สมาชิกสมาคม -->
                    <td class="text-nowrap"><span class="font-monospace">{{ getRowMemberNo(record) }}</span></td>

                    <!-- 4. บริษัท/หน่วยงาน -->
                    <td>{{ getRowOrganization(record) }}</td>

                    <!-- 5. ชื่อรายการ -->
                    <td>{{ getRowItemTitle(record) }}</td>

                    <!-- 6. จำนวนเงิน -->
                    <td class="text-end text-nowrap">
                      <strong>{{ formatCurrency(getRowAmount(record)) }}</strong> บาท
                    </td>

                    <!-- 7. สถานะการชำระเงิน -->
                    <td class="text-center">
                      <span class="badge" [ngClass]="getRowPaymentStatusClass(record)">
                        {{ getRowPaymentStatus(record) }}
                      </span>
                    </td>

                    <!-- 8. วันที่และเวลาชำระเงิน -->
                    <td class="text-nowrap">{{ getRowPaidAt(record) }}</td>

                    <!-- 9. หลักฐานการชำระเงิน (คลิกเพื่อดูแบบย่อ-ขยายได้) -->
                    <td class="text-center" (click)="$event.stopPropagation()">
                      <button *ngIf="getRowPaymentSlip(record)" class="btn btn-sm btn-outline-primary"
                        type="button" (click)="openSlipPreview(getRowPaymentSlip(record)!)"
                        [ngbTooltip]="'ดูหลักฐานการชำระเงิน'">
                        <i class="bi bi-receipt me-1"></i>ดูหลักฐาน
                      </button>
                      <span *ngIf="!getRowPaymentSlip(record)" class="text-muted">-</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!-- Pagination -->
          <div class="card-footer">
            <div class="d-flex justify-content-between align-items-center">
              <div class="text-muted">
                แสดงผล {{ ((page - 1) * pageSize) + 1 }} - {{ min(page * pageSize, collectionSize) }}
                จาก {{ collectionSize }} รายการ
              </div>
              <ngb-pagination [(page)]="page" [pageSize]="pageSize" [collectionSize]="collectionSize" [maxSize]="5"
                [rotate]="true" [boundaryLinks]="true" [size]="'sm'" (pageChange)="onPageChange($event)">
              </ngb-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Receipt Log Selection Modal (Exam tab) -->
<ng-template #receiptLogModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">
      <i class="bi bi-receipt me-2"></i>เลือกใบเสร็จ
    </h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <!-- Loading -->
    <div *ngIf="receiptLogLoading" class="text-center py-4">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
      <p class="mt-2 text-muted">กำลังโหลดข้อมูลใบเสร็จ...</p>
    </div>

    <!-- Empty -->
    <div *ngIf="!receiptLogLoading && receiptLogs.length === 0" class="text-center py-4 text-muted">
      <i class="bi bi-inbox fs-3 d-block mb-2"></i>ไม่พบข้อมูลใบเสร็จ
    </div>

    <!-- Summary badges -->
    <div *ngIf="!receiptLogLoading && receiptLogSummary" class="d-flex gap-2 mb-3">
      <span class="badge bg-success">สร้างใหม่ {{ receiptLogSummary.created }} รายการ</span>
      <span class="badge bg-danger">ยกเลิก {{ receiptLogSummary.canceled }} รายการ</span>
    </div>

    <!-- Table -->
    <div *ngIf="!receiptLogLoading && receiptLogs.length > 0" class="table-responsive">
      <table class="table table-hover table-bordered align-middle mb-0">
        <thead class="table-light">
          <tr>
            <th class="text-center" style="width: 5%;">#</th>
            <th style="width: 25%;">เลขที่ใบเสร็จ</th>
            <th class="text-center" style="width: 15%;">ประเภท</th>
            <th class="text-end" style="width: 18%;">จำนวนเงิน</th>
            <th style="width: 22%;">วันที่โอน</th>
            <th class="text-center" style="width: 15%;">สถานะ</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let log of receiptLogs; let i = index"
              style="cursor: pointer;"
              (click)="selectReceiptLog(log)"
              title="คลิกเพื่อดูใบเสร็จฉบับนี้">
            <td class="text-center text-muted">{{ i + 1 }}</td>
            <td><strong>{{ log.codeReceipt }}</strong></td>
            <td class="text-center">
              <span class="badge" [ngClass]="getReceiptLogTypeBadgeClass(log.type)">
                {{ getReceiptLogTypeLabel(log.type) }}
              </span>
              <div *ngIf="log.type === 'canceled' && log.cancelReason"
                class="small text-danger mt-1" title="{{ log.cancelReason }}">
                <i class="bi bi-info-circle me-1"></i>{{ log.cancelReason }}
              </div>
            </td>
            <td class="text-end">{{ formatCurrency(parseFloat(log.amount)) }} บาท</td>
            <td>{{ log.transferDateTime }}</td>
            <td class="text-center">
              <span class="badge bg-success">{{ log.status }}</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="modal.dismiss()">ปิด</button>
  </div>
</ng-template>
<!-- Payment Slip Preview (ย่อ-ขยายได้) -->
<div class="slip-preview-overlay" *ngIf="showSlipPreview" (click)="closeSlipPreview()"
  (mousemove)="onSlipDragMove($event)" (mouseup)="onSlipDragEnd()" (mouseleave)="onSlipDragEnd()">
  <div class="slip-preview-dialog" (click)="$event.stopPropagation()">
    <!-- Toolbar -->
    <div class="slip-preview-toolbar">
      <span class="slip-preview-title">
        <i class="bi bi-receipt me-2"></i>หลักฐานการชำระเงิน
      </span>

      <div class="slip-preview-actions">
        <ng-container *ngIf="!slipPreviewIsPdf">
          <button type="button" class="btn btn-sm btn-light" (click)="zoomSlipOut()" [ngbTooltip]="'ย่อ'">
            <i class="bi bi-zoom-out"></i>
          </button>
          <span class="slip-zoom-level">{{ slipZoomPercent }}%</span>
          <button type="button" class="btn btn-sm btn-light" (click)="zoomSlipIn()" [ngbTooltip]="'ขยาย'">
            <i class="bi bi-zoom-in"></i>
          </button>
          <button type="button" class="btn btn-sm btn-light" (click)="resetSlipZoom()" [ngbTooltip]="'ขนาดเดิม'">
            <i class="bi bi-arrow-counterclockwise"></i>
          </button>
        </ng-container>

        <button type="button" class="btn btn-sm btn-light" (click)="openSlipInNewTab()" [ngbTooltip]="'เปิดในแท็บใหม่'">
          <i class="bi bi-box-arrow-up-right"></i>
        </button>
        <button type="button" class="btn btn-sm btn-light" (click)="closeSlipPreview()" [ngbTooltip]="'ปิด'">
          <i class="bi bi-x-lg"></i>
        </button>
      </div>
    </div>

    <!-- Body -->
    <div class="slip-preview-body" [class.is-zoomed]="slipZoom > 1"
      (wheel)="!slipPreviewIsPdf && onSlipWheel($event)" (mousedown)="onSlipDragStart($event)">
      <iframe *ngIf="slipPreviewIsPdf" [src]="slipPreviewUrl | safe:'resourceUrl'" class="slip-preview-pdf"
        title="หลักฐานการชำระเงิน">
      </iframe>

      <img *ngIf="!slipPreviewIsPdf" [src]="slipPreviewUrl" alt="หลักฐานการชำระเงิน" class="slip-preview-image"
        [style.transform]="'translate(' + slipOffsetX + 'px, ' + slipOffsetY + 'px) scale(' + slipZoom + ')'"
        draggable="false">
    </div>

    <!-- Hint -->
    <div class="slip-preview-hint" *ngIf="!slipPreviewIsPdf">
      <i class="bi bi-info-circle me-2"></i>
      <span>เลื่อนลูกกลิ้งเมาส์เพื่อย่อ-ขยาย · ลากเพื่อเลื่อนภาพเมื่อขยายแล้ว · กด Esc หรือคลิกพื้นหลังเพื่อปิด</span>
    </div>
  </div>
</div>
